export class CriteriaSort {
  direction: 'ASC' | 'DESC';
  property: string;
}

export class Criteria {
  page?: number;
  size?: number;
  distinct?: boolean;
  sorts?: CriteriaSort[];
}
